import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { InfoTooltipLink, StandardSelect } from 'components'
import { isEmpty, compact } from 'lodash'

const FILTER_KEY = 'unforeseenEvents'

const UnforeseenEvents = ({
  defaultValue,
  translate,
  unforeseenEventsSchema,
  multiples,
  filters,
  setFilters,
  handleMultiChange,
}) => {
  /**
   * Check if the filter is present and set the values to render the pills
   */
  useEffect(() => {
    const newFilters = compact(filters?.filter((f) => f !== FILTER_KEY))
    const isPresent = !isEmpty(defaultValue?.unforeseenEvents)
    setFilters(isPresent ? [...newFilters, FILTER_KEY] : newFilters)
  }, [defaultValue.unforeseenEvents])

  return (
    <>
      <Row>
        <Col className="d-flex">
          {translate('search_unforeseen')}
          <InfoTooltipLink
            link={translate('programSearchUnforeseenEventsLink')}
            text={translate('tooltipProgramSearchUnforeseenEvents')}
            className="ml-2"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <StandardSelect
            isMulti
            options={unforeseenEventsSchema}
            onChange={(types) =>
              handleMultiChange('unforeseenEvents', types, 'elementValue')
            }
            value={
              defaultValue?.unforeseenEvents?.map((item) => ({
                elementValue: item,
              })) || multiples?.unforeseenEvents
            }
            isClearable
            getOptionLabel={({ elementValue }) => elementValue}
            getOptionValue={({ elementValue }) => elementValue}
            placeholder=""
          />
        </Col>
      </Row>
    </>
  )
}

export default UnforeseenEvents
